import { Image } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';
import { sanitize } from 'isomorphic-dompurify';

import * as icons from '@gn-audio/icons';
import { icon_arrow_right } from '@gn-audio/icons';
import {
  Button,
  ButtonVariantType,
  getContrastThemeClass,
  JabraIcon,
  resolveBackgroundStyle,
} from '@gn-audio/jss-components';

import { LinkBlockItem } from 'composables/shared/LinkBlock/LinkBlockItem.model';

export const LinkBlockItemComponent = ({ block }: { block: LinkBlockItem }) => {
  const { description, title, icon, buttonVariant, link, image, backgroundColor, linkText } = block;
  const iconName = icon.value;
  const iconComponent = iconName ? (icons as any)[iconName] : undefined;
  const blockBackgroundColor = resolveBackgroundStyle(backgroundColor?.value) || {
    backgroundColor: '#ffffff',
  };
  const blockThemeClass = getContrastThemeClass(backgroundColor?.value);

  const hasImage = !!image.value?.src;

  const variant = buttonVariant.value ? (buttonVariant.value as ButtonVariantType) : 'secondary';
  return (
    <div
      className={classNames(
        'flex w-full flex-col items-start gap-3 rounded-xl border border-solid border-gray-500 p-6 dark:border-gray-700',
        blockThemeClass
      )}
      style={blockBackgroundColor}
      key={block.id}
    >
      <div className="mb-4">
        {hasImage ? (
          <Image className="w-auto rounded-md object-contain" field={image} />
        ) : (
          !!iconComponent && <JabraIcon className="size-20" Icon={iconComponent} />
        )}
      </div>

      <h2
        className="heading-5 mt-auto"
        dangerouslySetInnerHTML={{ __html: sanitize(title.value) }}
      />
      <div
        className="paragraph mb-6"
        dangerouslySetInnerHTML={{ __html: sanitize(description.value) }}
      />
      <Button
        asLink={true}
        href={link.value.href}
        variant={variant}
        size="m"
        title={link.value.title}
        target={link.value.target}
        iconPlacement="right"
        icon={<JabraIcon Icon={icon_arrow_right} />}
      >
        {linkText.value}
      </Button>
    </div>
  );
};
